<ng-container *ngIf="lowLevelTitle$|async as vm">
  <ng-container *ngIf="!vm.title">
    <div class="row">
      <div class="col-12">
        <h5 class="my-3 text-mad text-uppercase">Land Area</h5>
        <hr class="active" />
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="vm.title">
    <div class="row">
      <div class="col-12">
        <h5 class="my-3 text-black text-uppercase">
          {{vm.title}}
        </h5>
      </div>
    </div>
  </ng-container>
</ng-container>

<div class="row">
  <div class="col-12 d-flex justify-content-end">
    <button class="btn btn-primary" type="button" (click)="onAddItem()">
      Add Component
    </button>
  </div>
</div>

<div class="row mt-4">
  <div class="col-12">
    <mat-table [dataSource]="dataSource$">
      <ng-container matColumnDef="index">
        <mat-header-cell *matHeaderCellDef>Land Parcel Component</mat-header-cell>
        <mat-cell *matCellDef="let item; let index = index">
          {{ index + 1 }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="unit_area_measurement">
        <mat-header-cell *matHeaderCellDef>Area Unit Type</mat-header-cell>
        <mat-cell *matCellDef="let item">
          {{ item.unitAreaMeasurementName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="surface">
        <mat-header-cell *matHeaderCellDef>Surface</mat-header-cell>
        <mat-cell *matCellDef="let item">
          {{ item.surface | mask:'separator':{thousandSeparator:','} }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="limited_use">
        <mat-header-cell *matHeaderCellDef>Restricted / limited use</mat-header-cell>
        <mat-cell *matCellDef="let item">
          {{ item.limitedUse ? item.limitedUse : 'N/A' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="3d_restriction">
        <mat-header-cell *matHeaderCellDef>3D restriction</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <div
            *ngIf="(item.undergroundRestriction > 0 || item.aerialRestriction > 0) && item.unitLengthMeasurementAcronym; else na">
              {{
                item.undergroundRestriction > 0
                  ? 'Depth: ' + (item.undergroundRestriction | mask:'separator':{thousandSeparator: ','} ) + item.unitLengthMeasurementAcronym
                  : ''
              }}
              {{item.undergroundRestriction > 0 && item.aerialRestriction > 0 ? ', ' : ''}}
              {{
                item.aerialRestriction > 0
                ? 'Height: ' + (item.aerialRestriction | mask:'separator':{thousandSeparator: ','} ) + item.unitLengthMeasurementAcronym
                : ''
              }}
          </div>
          <ng-template #na>
            N/A
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
        <mat-cell *matCellDef="let item; let index = index">
          <button mat-icon-button type="button" color="primary" (click)="onEditItem({item, index})">
            <mat-icon>create</mat-icon>
          </button>

          <button mat-icon-button type="button" color="warn" (click)="onDeleteItem(index)">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row
        *matHeaderRowDef="['index', 'unit_area_measurement', 'surface', 'limited_use', '3d_restriction', 'actions']"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: ['index', 'unit_area_measurement', 'surface', 'limited_use', '3d_restriction', 'actions']"></mat-row>
    </mat-table>
  </div>
</div>

<ng-container [formGroup]="form">
  <div class="row mt-4">
    <div class="col-lg-4">
      <mat-form-field class="mat-form-field-fluid">
        <mat-select placeholder="Quality of soil and degradation" formControlName="qos_degradation_id">
          <mat-option>
            <div (click)="onAddQosDegradation()" class="add-entry">
              <i class="ki ki-plus"></i> New quality of soil and degradation
            </div>
          </mat-option>
          <mat-option *ngFor="let qosDegradation of qosDegradations$|async"
            [value]="qosDegradation.id">{{qosDegradation.name}}</mat-option>
        </mat-select>
        <mat-error>
          Quality of soil and degradation
          <strong>required</strong>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-lg-4">
      <mat-form-field class="mat-form-field-fluid">
        <input matInput placeholder="Environmental considerations" formControlName="env_considerations" />
        <mat-icon matSuffix class="cursor-pointer" (click)="$event.stopPropagation();" container="body"
          [ngbPopover]="'TOOLTIP.LAND_PARCEL.ENV_CONSIDERATION.DESCRIPTION' | translate">help
        </mat-icon>
      </mat-form-field>
    </div>
    <div class="col-lg-4 kt-margin-bottom-10-mobile mt-4">
      <mat-form-field class="mat-form-field-fluid">
        <input matInput placeholder="Other considerations" formControlName="other_considerations" />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <span class="font-weight-bold">Zoning</span>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <mat-form-field class="mat-form-field-fluid">
        <mat-select placeholder="Planning Status of the land parcel" formControlName="planning_status_id">
          <mat-option>
            <div (click)="onAddPlanningStatus()" class="add-entry">
              <i class="ki ki-plus"></i> New planning status
            </div>
          </mat-option>
          <mat-option *ngFor="let planingStatus of planningStatuses$|async"
            [value]="planingStatus.id">{{planingStatus.name}}</mat-option>
        </mat-select>
        <mat-error>
          Planning Status of the land parcel
          <strong>required</strong>
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-12 d-flex align-items-center" style="gap: 1rem;">
      <button type="button" mat-raised-button color="primary" (click)="onClickUploadFile('zoning')">
        Upload file
      </button>
      <div class="d-flex align-items-center" style="gap: 0.5rem">
        <button type="button" mat-icon-button color="primary" 
          (click)="onPreviewUploadedFile({name: form.controls.zoning_file_name.value, path: form.controls.zoning_file_path.value})"
          *ngIf="form.controls.zoning_file_name.value">
          <mat-icon>remove_red_eye</mat-icon>
        </button>
        <div>
          <span class="font-weight-bold">File name: </span>
          <ng-container *ngIf="form.controls.zoning_file_name.value">
            <span style="color: green">{{form.controls.zoning_file_display_name.value}}</span>
          </ng-container>
          <ng-container *ngIf="!form.controls.zoning_file_name.value">
            <span style="color: red">N/A</span>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <mat-form-field class="mat-form-field-fluid">
        <textarea matInput placeholder="Comments" formControlName="zoning_comment">
        </textarea>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <span class="font-weight-bold">Heritage building</span>
    </div>
  </div>
  <div class="row">
    <div class="col-12 d-flex align-items-center" style="gap: 1rem;">
      <button type="button" mat-raised-button color="primary" (click)="onClickUploadFile('heritage')">
        Upload file
      </button>
      <div class="d-flex align-items-center" style="gap: 0.5rem">
        <button type="button" mat-icon-button color="primary" 
          (click)="onPreviewUploadedFile({name: form.controls.heritage_file_name.value, path: form.controls.heritage_file_path.value})"
          *ngIf="form.controls.heritage_file_name.value">
          <mat-icon>remove_red_eye</mat-icon>
        </button>
        <div>
          <span class="font-weight-bold">File name: </span>
          <ng-container *ngIf="form.controls.heritage_file_name.value">
            <span style="color: green">{{form.controls.heritage_file_display_name.value}}</span>
          </ng-container>
          <ng-container *ngIf="!form.controls.heritage_file_name.value">
            <span style="color: red">N/A</span>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <mat-form-field class="mat-form-field-fluid">
        <textarea matInput placeholder="Comments" formControlName="heritage_comment">
        </textarea>
      </mat-form-field>
    </div>
  </div>
</ng-container>